<tax-page-header [titleText]="kkmName" [showBackButton]="true"></tax-page-header>

<tax-retail-place-info
  *ngIf="retailPlaceId"
  [retailPlaceId]="retailPlaceId"
></tax-retail-place-info>

<tax-select-kkm-tariffs-list
  *ngIf="(bpStep$ | async) === 'selectTariff'"
  (changeTariff)="setTariffsRange($event)"
></tax-select-kkm-tariffs-list>

<tax-kkm-tariff-form
  *ngIf="(bpStep$ | async) === 'selectOptions'"
  [selectedTariff]="selectedTariff"
  [selectedTariffsRange]="selectedTariffsRange"
  [kkmProcessFields]="kkmProcessFields"
  [kkmId]="kkmId$ | async"
></tax-kkm-tariff-form>
